var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.getSettings.adType)?_c('div',{staticClass:"C-block-type-26"},[_c(_vm.getSettings.component,{tag:"component",attrs:{"ad-type":_vm.getSettings.adType,"settings":_vm.getSettings.data}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }